import {
  Group,
  Grid,
  List,
  Text,
  useMantineTheme,
  Flex,
  ActionIcon,
  Transition,
  CloseButton,
  Box,
} from "@mantine/core";
import { useModals } from "@mantine/modals";
import { useContext, useEffect, useState } from "react";
import ActionCard from "src/components/ActionCard";
import { CreateClientGroupForm } from "./CreateClientGroupForm";
import {
  Client,
  UserRole,
  useGetClientGroupManyLazyQuery,
} from "src/generated/graphql";
import { IconDotsVertical } from "@tabler/icons";
import { AddClientToGroupForm } from "./AddClientToGroupForm";
import { EditClientGroupForm } from "./EditClientGroupForm";
import { useClickOutside } from "@mantine/hooks";
import { FaMinusCircle } from "react-icons/fa";
import { useRemoveClientFromGroupMutation } from "src/generated/graphql";
import { GetClientGroupMany } from "src/api/graphql/queries/Client";
import { AppContext } from "src/api/AppContext";
import { RiPencilFill } from "react-icons/ri";
import { IoIosAddCircle } from "react-icons/io";
import { EMPLOYEE_ROLE_OBJ } from "src/utils/constants";
import useWritePermission from "src/hooks/usePermission";
import Roles from "src/modules/Roles";
interface ClientGroupProps {
  clientId: string | undefined;
  client: any;
  //   onRefetch: () => void;
}

interface RemoveClientFromGroupInput {
  clientId: string;
  clientGroupId: string;
}

const ClientGroups = ({ clientId, client }: ClientGroupProps) => {
  const isAllowWrite = useWritePermission(EMPLOYEE_ROLE_OBJ.clients);
  const modals = useModals();
  const [getClientGroups, { data }] = useGetClientGroupManyLazyQuery();
  const refetchQuery = [
    { query: GetClientGroupMany, variables: { id: clientId } },
  ];
  const theme = useMantineTheme();
  const [activeOption, setActiveOption] = useState<string | undefined>(
    undefined
  );
  let color = theme.colors.secondaryTextColor[4];
  const { currentUser } = useContext(AppContext);

  const [removeClientFromGroup, { loading }] = useRemoveClientFromGroupMutation(
    {
      onCompleted: () => {},
      refetchQueries: refetchQuery,
    }
  );

  useEffect(() => {
    fetchClientGroups();
  }, [clientId]);

  const fetchClientGroups = () => {
    getClientGroups({
      variables: {
        id: clientId,
      },
    });
  };

  const handleClientGroupModal = () => {
    const { user } = client || {};
    const clientName = `${user?.firstName + user?.lastName}`;
    modals.openModal({
      closeOnClickOutside: false,
      title: "Add Account Group",
      children: (
        <CreateClientGroupForm
          clientId={clientId}
          clientName={clientName}
          handleClose={handleClose}
        />
      ),
    });
  };

  const handleClientGroupEdit = (groupId: string, clientGroupName: string) => {
    modals.openModal({
      closeOnClickOutside: false,
      title: "Edit Account Group",
      children: (
        <EditClientGroupForm
          clientId={clientId}
          clientGroupId={groupId}
          clientGroupName={clientGroupName}
          handleClose={handleClose}
        />
      ),
    });
  };

  const handleClientsModal = (clientGroupId: string) => {
    modals.openModal({
      closeOnClickOutside: false,
      title: "Add Accounts To Group",
      children: (
        <AddClientToGroupForm
          clientId={clientId}
          clientGroupId={clientGroupId}
          handleClose={handleClose}
        />
      ),
    });
  };

  const handleClose = () => {
    modals.closeAll();
  };

  const handleOpenListMenu = (option: string) => {
    setActiveOption(option);
  };

  const outsideClickRef = useClickOutside(() => {
    setActiveOption(undefined);
  });

  const handleRemoveClient = ({
    clientGroupId,
    clientId,
  }: RemoveClientFromGroupInput) => {
    removeClientFromGroup({
      variables: {
        clientId: clientId!,
        clientGroupId: clientGroupId!,
      },
    });
  };
  return (
    <>
      <Group position="apart" mt="lg" mb="sm">
        <ActionCard
          title="Groups"
          handleModal={isAllowWrite ? handleClientGroupModal : undefined}
        >
          {/* MAP SECTIONS HERE */}
          {data?.clientGroupMany?.map((value) => {
            const {
              clients,
              primaryClient: { user },
            } = value;
            return (
              <ActionCard
                key={"groupCard-" + value.id}
                title={value?.name}
                my={15}
                style={{
                  backgroundColor: theme.colors.primary[0],
                }}
                rightIconButton={
                  user.id === currentUser?.id ||
                  currentUser?.role === UserRole.Admin ? (
                    <RiPencilFill
                      style={{ cursor: "pointer", marginRight: "20px" }}
                      size={20}
                      onClick={() =>
                        handleClientGroupEdit(value.id, value.name)
                      }
                    />
                  ) : null
                }
              >
                <Flex my={5}>
                  <Text
                    mx={5}
                    fw={600}
                    color={theme.colors.primaryTextColor[0]}
                  >
                    Primary Account: {`${user.firstName} ${user.lastName}`}
                  </Text>
                </Flex>
                <Box>
                  <List
                    w="100%"
                    listStyleType="none"
                    style={{
                      color: theme.colors.secondaryTextColor[4],
                      borderRadius: "4px",
                      padding: "0px 10px",
                      backgroundColor: theme.colors.secondary[4],
                    }}
                  >
                    <List.Item
                      w="100%"
                      icon={null}
                      c={color}
                      sx={{
                        "& .mantine-List-itemWrapper": {
                          display: "flex",
                          borderBottom: `1px solid ${theme.colors.secondaryTextColor[4]}`,
                        },
                        "& .mantine-List-itemWrapper > span > div": {
                          alignItems: "center",
                        },
                      }}
                    >
                      <Flex justify="space-between" align="center">
                        <Text size={13} fw={700} my={isAllowWrite ? 0 : "xs"}>
                          {`Linked Accounts  -  ${clients?.length}`}
                        </Text>
                        {isAllowWrite && (
                          <ActionIcon
                            size="xl"
                            c={theme.colors.secondaryTextColor[4]}
                            onClick={() => handleClientsModal(value.id)}
                            sx={{
                              color,
                              "&:hover": {
                                backgroundColor: theme.colors.secondary[2],
                                color: theme.colors.primary[0],
                              },
                            }}
                          >
                            <IoIosAddCircle size={24} />
                          </ActionIcon>
                        )}
                      </Flex>
                    </List.Item>
                    {clients?.map((item, index) => {
                      return (
                        <List.Item
                          w="100%"
                          icon={null}
                          key={value.id + item.id}
                          c={color}
                          sx={{
                            "&": {
                              position: "relative",
                            },
                            "& ::marker": {
                              content: "none",
                            },
                            "& .mantine-List-itemWrapper": {
                              display: "flex",
                              borderBottom:
                                index + 1 < clients.length
                                  ? "1px solid lightgrey"
                                  : "none",
                            },
                            "& .mantine-List-itemWrapper > span > div": {
                              alignItems: "center",
                              paddingLeft: "10px 10px",
                            },
                          }}
                        >
                          <Flex justify="space-between" align="center">
                            <Text
                              size={13}
                              fw={500}
                              my={isAllowWrite ? 0 : "xs"}
                            >
                              {`${item?.user.firstName}  ${item?.user.lastName}`}
                            </Text>
                            {isAllowWrite && (
                              <ActionIcon
                                size="xl"
                                c={theme.colors.light[5]}
                                onClick={() =>
                                  handleOpenListMenu(value.id + item.id)
                                }
                                sx={{
                                  "&:hover": {
                                    backgroundColor: theme.colors.secondary[2],
                                  },
                                }}
                              >
                                <IconDotsVertical />
                              </ActionIcon>
                            )}

                            <Transition
                              mounted={activeOption === value.id + item.id}
                              transition="slide-left"
                              duration={200}
                              timingFunction="ease-in-out"
                            >
                              {(styles) => (
                                <Flex
                                  my={1}
                                  justify="flex-end"
                                  bg={theme.colors.secondary[2]}
                                  style={{
                                    ...styles,
                                    position: "absolute",
                                    top: 0,
                                    right: 0,
                                    padding: "0px 4px",
                                    borderRadius: 4,
                                  }}
                                  ref={outsideClickRef}
                                >
                                  <ActionIcon
                                    variant="light"
                                    color="red.4"
                                    size="lg"
                                    my={4}
                                    disabled={loading}
                                    onClick={() =>
                                      handleRemoveClient({
                                        clientGroupId: value.id,
                                        clientId: item.id,
                                      })
                                    }
                                    sx={{
                                      width: 180,
                                      backgroundColor:
                                        theme.colors.secondary[2],
                                      "&:hover": {
                                        backgroundColor:
                                          theme.colors.secondary[4],
                                      },
                                    }}
                                  >
                                    <FaMinusCircle />{" "}
                                    <Text ml={10}> Remove Account</Text>
                                  </ActionIcon>

                                  <CloseButton
                                    size="lg"
                                    c={theme.colors.light[5]}
                                    disabled={loading}
                                    onClick={() => setActiveOption(undefined)}
                                    my={4}
                                    sx={{
                                      "&:hover": {
                                        backgroundColor:
                                          theme.colors.secondary[4],
                                      },
                                    }}
                                  />
                                </Flex>
                              )}
                            </Transition>
                          </Flex>
                        </List.Item>
                      );
                    })}
                  </List>
                </Box>
              </ActionCard>
            );
          })}
        </ActionCard>
      </Group>
    </>
  );
};

export default ClientGroups;
